import mapboxgl from "mapbox-gl";
import ReactDOM from "react-dom/client";
import { view } from "../../helpers";

function PopUp({ map, coordinates, children }) {
  view.moveToCoordinates(map, coordinates);
  
  const container = document.createElement("div");
  // Render the React component into the container
  const root = ReactDOM.createRoot(container);
  root.render(<>{children}</>);

  new mapboxgl.Popup({
    closeButton: false,
    offset: {
      top: [0, 10], // 10px margin on top
      bottom: [0, -10], // 10px margin on bottom
      left: [10, 0], // 10px margin on left
      right: [-10, 0], // 10px margin on right
    },
    className: "custom-popup absolute z-50",
  })
    .setLngLat(coordinates)
    .setDOMContent(container)
    .addTo(map);
}

export default PopUp;
